import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {EventsManager} from 'src/app/services/events.manager';

@Injectable({
  providedIn: 'root'
})

export class UtilService {
  private _httpClient = inject(HttpClient);
  private _eventsManager = inject(EventsManager);

  public getTermsOfUse(): Observable<any> {
    return this._httpClient.get(environment.apiUrl + environment.treatmentApi + 'files/public-documents/terms-of-use.html');
  }

  public getPrivacyPolicy(): Observable<any> {
    return this._httpClient.get(environment.apiUrl + environment.treatmentApi + 'files/public-documents/privacy-policy.html');
  }

  public getStates(): Observable<any> {
    return this._httpClient.get('data/states.json');
  }

  public setAllowedStates(states: any): any {
    return this._eventsManager.states.filter(function (s: any) {
      return (states.includedStates.indexOf(s.abbr) >= 0);
    }).map(a => a);
  }
}
